var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"76","height":"11","fill":"none"}},[_c('path',{attrs:{"fill":"#d3d8e0","d":"M0 0c0 6.075 4.925 11 11 11h54c6.075 0 11-4.925 11-11z"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"m34 7 3.5-3L41 7"}})])
}
var staticRenderFns = []

export default { render: render }